export const orderHandler = {
    pathPattern: '/brands/:brandId/orders/:orderId',
    toWeb: ({ brandId, orderId }) => ({
        path: `/brands/${brandId}/orders/${orderId}`,
    }),
    toNative: ({ brandId, orderId }, locationId) => `/${brandId}/${locationId}/orders/${orderId}`,
    meta: {
        title: 'Order detail',
        description: 'Opens a specific order in the operator dashboard.',
        status: 'live',
        platforms: { web: true, ios: false, android: false },
        flag: null,
        params: [
            { name: 'brandId', in: 'path', required: true },
            { name: 'orderId', in: 'path', required: true },
        ],
        example: {
            params: { brandId: 'BXqExampleBrandId', orderId: 'exampleOrderId' },
            locationId: 'exampleLocationId',
        },
    },
};
//# sourceMappingURL=order.js.map